<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="CURSOS" key="1">
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  modalWidth="80%"
                  ref="master"
                  @action="masterActions"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                  <a-input
                    v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :params="categorias"
                            :label="$t('Categorías') "
                            :selectConfig="{mode:'multiple'}"
                            :formItemConfig="fiOptions"
                            :decorator="['categories', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :params="herramientas"
                            :label="$t('Herramientas') "
                            :selectConfig="{mode:'multiple'}"
                            :formItemConfig="fiOptions"
                            :decorator="['tools', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Descripción') ">
                  <a-textarea autoSize
                              v-decorator="['description', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Estado')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Capacitaciones" key="1">
        <training v-if="rowSelected" :id_course="rowSelected"/>
        <span v-else>Seleccione un curso para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        categorias: {h_lookup_type: 'TRN_CATEGORIAS'},
        herramientas: {h_lookup_type: 'TRN_HERRAMIENTAS'},
        master: {
          endpoint: 'course',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Categorías', dataIndex: 'categorias', sorter: true},
              {title: 'Herramientas', dataIndex: 'herramientas', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true}
            ]
          }
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        }
      }
    },
    methods: {
      masterActions (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.categories)) {
              this.$refs.master.modal.form.setFieldsValue({
                categories: action.record.categories.split(',')
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                categories: undefined
              })
            }
            if (!this.$isEmpty(action.record.tools)) {
              this.$refs.master.modal.form.setFieldsValue({
                tools: action.record.tools.split(',')
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                tools: undefined
              })
            }

            break
        }
      }
    },
    computed: {
      rowSelected () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/Course.vue